import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbCaretRight: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
      <title>abb_caret-right_24</title>
      <g id='Box'>
        <rect fill='none' transform='translate(0 24) rotate(-90)' />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <polygon fill={fill} points='15 12 9.04 18 8 16.95 12.9 12 8 7.05 9.04 6 15 12' />
      </g>
    </svg>
  );
};
